import { primitive } from 'styles/constants';
export const headerWidgetTheme = {
  background: `radial-gradient(circle at 50% 0, #ff9930, #db680a)`,
  textColor: primitive.$mayoEggWhite,
  headerFlexDirection: 'column',
};
